import { useEffect, useState } from "react";
import { DatabaseZap, RefreshCw } from "lucide-react";

/** iter371 — bandeau global pendant une coupure base : affiché au 1er réessai, retiré dès qu'une lecture réussit. */
export default function DbOutageBanner() {
  const [st, setSt] = useState(null);
  useEffect(() => {
    const h = (e) => setSt(e.detail?.on ? { attempt: e.detail.attempt } : null);
    window.addEventListener("ledesk:db-outage", h);
    return () => window.removeEventListener("ledesk:db-outage", h);
  }, []);
  if (!st) return null;
  return (
    <div role="status" className="fixed left-0 right-0 flex items-center justify-center" style={{ top: 0, zIndex: 1400, gap: 10, padding: "8px 16px", background: "#2a1f0e", borderBottom: "0.5px solid #E0A42E", color: "#E0A42E", fontSize: 12.5, fontWeight: 600 }} data-testid="db-outage-banner">
      <DatabaseZap size={15} />
      <span>Connexion à la base momentanément perdue, nouvel essai… <span className="tabular-nums" style={{ color: "#f1c56a" }}>(essai {st.attempt}/3)</span></span>
      <RefreshCw size={13} className="animate-spin" />
    </div>
  );
}
